// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

(function () {


	let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu) => {
		if (itemMenu.querySelector('.submenu')) {
			const event = ["mouseenter", "mouseleave"];
			event.forEach((event) => {
				itemMenu.addEventListener(event, () => {
					itemMenu.classList.toggle('hover')
					itemMenu.querySelector('.submenu').classList.toggle('show')
				})
			})
		}
	})

	let itemsMenuMobile = document.querySelectorAll('.inner ul li');
	itemsMenuMobile.forEach((itemMenuMobile) => {
		if (itemMenuMobile.querySelector('.submenu')) {
			// Use click event for mobile devices
			itemMenuMobile.addEventListener('click', function (e) {
				// Prevent toggling when clicking inside submenu
				if (e.target.closest('.submenu')) return;
				e.stopPropagation();
				itemMenuMobile.classList.toggle('hover');
				itemMenuMobile.querySelector('.submenu').classList.toggle('show');
			});
		}
	});

	// Optional: Close other open submenus when opening a new one
	document.addEventListener('click', function (e) {
		itemsMenuMobile.forEach((itemMenuMobile) => {
			if (
				itemMenuMobile.classList.contains('hover') &&
				!itemMenuMobile.contains(e.target)
			) {
				itemMenuMobile.classList.remove('hover');
				const submenu = itemMenuMobile.querySelector('.submenu');
				if (submenu) submenu.classList.remove('show');
			}
		});
	});

	window.onload = function () {
		/* updateMenuTabIndex();
		const menu = document.querySelector('#menu-container');
		if (menu) {
			menu.addEventListener('transitionend', updateMenuTabIndex);
		}  */

		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		});

	};

	const header = document.querySelector('.header');
	document.addEventListener('click', function (e) {
		if (e.target.closest('.header__burger')) {
			header.classList.toggle('nav-open');
		} else if (e.target.closest('.js-close-menu')) {
			header.classList.remove('nav-open');
		}
	});


	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//menu burger
	
	//open menu 
	document.querySelectorAll(".cta-menu-js").forEach( btn => {
		btn.addEventListener("click", (e)  => {
			console.log("click");
			e.preventDefault();
			document.querySelector("#burger-menu").classList.add("open")
			document.querySelector("body").classList.add("no-scroll")
		}, false)
	});

	//close menu
	if (document.querySelector(".burger-close-js")) {
		document.querySelector(".burger-close-js").addEventListener("click" , (e) => {
			e.preventDefault();
			document.querySelector("#burger-menu").classList.remove("open")
			document.querySelector("body").classList.remove("no-scroll")
		});
	}


	//LBX custom gallery
	const customLbx = new LBX('.js-custom-lbx');
	customLbx.icons.next =
		'<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55"><g id="Arrow"><polygon points="25.29 36.1 23.53 34.32 30.35 27.5 23.53 20.68 25.29 18.9 34.06 27.5 25.29 36.1" style="fill: #fff;"/></g><g id="Arrows"><g id="ArrowRight-Hover"><g id="BOX" style="isolation: isolate;"><path d="M55,54.99H0V.01h55v54.97Z" style="fill: #1e354b;"/></g><path id="Arrow-2" data-name="Arrow" d="M37.56,27.29c.33.33.33.87,0,1.2h0l-14.28,14.38c-.33.33-.85.33-1.18,0,0,0,0,0,0,0-.33-.33-.33-.87,0-1.2l13.68-13.78-13.7-13.78c-.33-.33-.33-.87,0-1.2.32-.33.85-.33,1.18,0,0,0,0,0,0,0h0l14.29,14.38Z" style="fill: #fff;"/></g></g></svg>'
	customLbx.icons.close =
		'<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="41.25" height="41.25" viewBox="0 0 41.25 41.25"><g><g id="Arrow"><polygon points="15.17 27.41 13.78 26 19.16 20.62 13.78 15.25 15.17 13.84 22.08 20.62 15.17 27.41" style="fill: #fff;"/></g><g id="Arrow-2" data-name="Arrow"><polygon points="26.08 27.41 27.47 26 22.09 20.62 27.47 15.25 26.08 13.84 19.17 20.62 26.08 27.41" style="fill: #fff;"/></g></g><g id="Arrows"><g id="ArrowRight-Hover"><g id="BOX" style="isolation: isolate;"><path d="M41.25,41.24H0V.01h41.25v41.23Z" style="fill: #1e354b;"/></g><path d="M21.4,20.66s0-.05,0-.08l10.23-10.3c.25-.25.25-.65,0-.9-.24-.25-.64-.25-.89,0,0,0,0,0,0,0l-10.12,10.18-10.12-10.18s0,0,0,0c-.25-.24-.64-.24-.89,0-.25.25-.25.65,0,.9l10.23,10.3s0,.05,0,.08l-10.22,10.3c-.25.25-.25.65,0,.9,0,0,0,0,0,0,.25.24.64.24.89,0l10.11-10.18,10.11,10.18c.24.25.64.25.89,0,0,0,0,0,0,0,.25-.25.25-.65,0-.9l-10.22-10.3Z" style="fill: #fff;"/></g></g></svg>'
	customLbx.icons.prev =
		'<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55"><g id="Arrow"><polygon points="25.29 36.1 23.53 34.32 30.35 27.5 23.53 20.68 25.29 18.9 34.06 27.5 25.29 36.1" style="fill: #fff;"/></g><g id="Arrows"><g id="ArrowRight-Hover"><g id="BOX" style="isolation: isolate;"><path d="M55,54.99H0V.01h55v54.97Z" style="fill: #1e354b;"/></g><path id="Arrow-2" data-name="Arrow" d="M37.56,27.29c.33.33.33.87,0,1.2h0l-14.28,14.38c-.33.33-.85.33-1.18,0,0,0,0,0,0,0-.33-.33-.33-.87,0-1.2l13.68-13.78-13.7-13.78c-.33-.33-.33-.87,0-1.2.32-.33.85-.33,1.18,0,0,0,0,0,0,0h0l14.29,14.38Z" style="fill: #fff;"/></g></g></svg>'

	if (document.querySelector('.expand-submenu')) {
		document.querySelectorAll('.expand-submenu').forEach((expand) => {
			expand.addEventListener('click', () => {
				expand.classList.toggle('active-menu');
				expand.nextElementSibling.classList.toggle('show');
			})
		})
	}

})();

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	// let logoHeaderImg = document.querySelector(".js-scroll-logo img");
	// let logoHeader = `${site_url}assets/svg/viva-anaheim-logo.svg`;
	// let logoHeaderScroll = `${site_url}assets/svg/viva-anaheim-scroll-logo.svg`;

	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
				// if (logoHeaderImg)
				// 	logoHeaderImg.setAttribute("src", logoHeaderScroll);
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
				// if (logoHeaderImg)
				// 	logoHeaderImg.setAttribute("src", logoHeaderScroll);
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
			// if (logoHeaderImg)
			// 	logoHeaderImg.setAttribute("src", logoHeader);
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

document.addEventListener('DOMContentLoaded', () => {
	/* Lightbox Gallerys */
	const customLightbox = new LBX('.js-lbx-gallery', {
		customClass: 'lbx-gallery',
		icons: {
			close: '<svg xmlns="http://www.w3.org/2000/svg" width="20.008" height="20.008" viewBox="0 0 20.008 20.008"><g transform="translate(-8.496 -8.496)"><line x2="19.52" y2="19.52" transform="translate(8.74 8.74)" fill="none" stroke="#2b3034" stroke-miterlimit="10" stroke-width="0.69"/><path d="M19.52,0,0,19.52" transform="translate(8.74 8.74)" fill="none" stroke="#2b3034" stroke-width="0.69"/></g></svg>',
			next: '<svg xmlns="http://www.w3.org/2000/svg" width="13.995" height="26.675" viewBox="0 0 13.995 26.675"><path id="Arrow" d="M405.661,3320.291a.745.745,0,0,1,0,1.049h0l-12.509,12.6a.733.733,0,0,1-1.041,0,.746.746,0,0,1,0-1.049l11.986-12.073-12-12.071a.745.745,0,0,1,0-1.048.732.732,0,0,1,1.041,0h0Z" transform="translate(-391.882 -3307.482)" fill="#2b3034"/></svg>',
			prev: '<svg xmlns="http://www.w3.org/2000/svg" width="13.995" height="26.675" viewBox="0 0 13.995 26.675"><path id="Arrow" d="M405.661,3320.291a.745.745,0,0,1,0,1.049h0l-12.509,12.6a.733.733,0,0,1-1.041,0,.746.746,0,0,1,0-1.049l11.986-12.073-12-12.071a.745.745,0,0,1,0-1.048.732.732,0,0,1,1.041,0h0Z" transform="translate(405.877 3334.157) rotate(180)" fill="#2b3034"/></svg>'
		}
	});
});

// accessibility remove role  //
document.addEventListener('DOMContentLoaded', function() {
	const elemento = document.querySelector('.accordion[role="tree"]');

	if (elemento) {
		elemento.removeAttribute('role');
	} 
});




// const tablesResp = document.querySelectorAll('.capacity-chart__copy table');
// if (tablesResp.length) {
// 	tablesResp.forEach((tablei) => {
// 		let tableresponsive = document.createElement('div')
// 		tableresponsive.classList.add('tableHold')
// 		tablei.parentNode.insertBefore(tableresponsive, tablei)
// 		tableresponsive.append(tablei)
// 		const ths = tablei.querySelectorAll('tr:first-child > *')
// 		tablei.querySelectorAll('tr + tr').forEach((row) => {
// 			const tds = row.querySelectorAll('td')
// 			let i = 0
// 			for (i; i < tds.length; i++) {
// 				tds[i].setAttribute('data-label', ths[i].textContent)
// 			}
// 		})
// 		const rowHeads = tablei.querySelectorAll('tr td:first-child')
// 		rowHeads.forEach((ele) => {
// 			ele.addEventListener('click', (ev) => {
// 				ele.closest('tr').classList.toggle('active')
// 			})
// 		})
// 	})
// }

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

// function updateMenuTabIndex() {
// 	const menu = document.querySelector('#menu-container');
// 	const isMenuVisible = menu && menu.classList.contains('show');
// 	const elements = document.querySelectorAll('#menu-container .privary-navigation__item a, #menu-container .social-media a');

// 	elements.forEach(element => {
// 		element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
// 	});
// } 
